<template>
  <tr v-on:click="move(fintech.id)" class="fintech-table-body-row">
    <td class="fintech-table-body-col">{{ publishedAt }}</td>
    <td class="fintech-table-body-col">{{ fintech.title }}</td>
    <td class="fintech-table-body-col for-pc">{{ fintech.subtitle }}</td>
  </tr>
</template>

<script>
  export default {
    props: [
      'fintech',
      'publishedAt'
    ],

    methods: {
      move (id) {
        location.href = '/fintechs/' + id;
        return false;
      }
    }
  }
</script>